import { render, staticRenderFns } from "./WorkflowFormSubmissionDetail.vue?vue&type=template&id=153b0d09&"
import script from "./WorkflowFormSubmissionDetail.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormSubmissionDetail.vue?vue&type=style&index=0&id=153b0d09&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports